import { Divider, Paper } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { AliasList } from '@/module/Dashboard/AliasList';
import { ProfileInfo } from '@/module/Dashboard/ProfileInfo';
import { ProfileDetails } from '@/module/Dashboard/model/DashboardTypes';

export interface ProfileDataProps {
  profileData: ProfileDetails;
}

export function ProfileData({ profileData }: ProfileDataProps) {
  const { t } = useTranslation();

  return (
    <Paper
      component="section"
      aria-label={t('dashboard.cards.profile')}
      flex={1}
      p="md"
      mih="200px"
    >
      <ProfileInfo info={profileData} />
      <Divider my={10} />
      <AliasList aliases={profileData.aliases} />
    </Paper>
  );
}
